import { isIsoDate } from '@fd/finance-core';
import { isSupportedCurrency } from '@fd/money';
import { v7 as uuidv7 } from 'uuid';
import { z } from 'zod';

/** Time-ordered id generated on the device, so records can be created and linked offline. */
export const newId = (): string => uuidv7();

export const Uuid = z.uuid();

/** Calendar date "YYYY-MM-DD" — a financial date, never a midnight timestamp. */
export const IsoDate = z.string().refine(isIsoDate, { message: 'Expected a calendar date YYYY-MM-DD' });

/** UTC timestamp with offset, e.g. 2026-09-27T12:00:00.000Z. */
export const Timestamp = z.iso.datetime({ offset: true });

/** Integer minor units as text (JSON has no bigint): "1999" = £19.99. */
/** At most 18 digits, so every value fits PostgreSQL bigint. */
export const MinorAmount = z.string().regex(/^-?\d{1,18}$/, 'Expected integer minor units');

/** Non-negative integer as text (weights, basis points). */
export const NonNegativeInteger = z.string().regex(/^\d{1,18}$/, 'Expected a non-negative integer');

export const CurrencyCode = z
  .string()
  .regex(/^[A-Z]{3}$/)
  .refine(isSupportedCurrency, { message: 'Unsupported currency' });

export const Name = z.string().trim().min(1).max(120);
export const OptionalText = (max: number) => z.string().max(max).nullable();
export const Color = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/)
  .nullable();

export type Uuid = z.infer<typeof Uuid>;
